import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { TicketsAndGuestsStateService } from 'app/manage-tickets-and-guests/services/tickets-and-guests-tabs.service';

@Component({
  selector: 'app-ticket-basket-raffle-allocation-list-page',
  templateUrl: './ticket-basket-raffle-allocation-list-page.component.html',
  styleUrls: ['./ticket-basket-raffle-allocation-list-page.component.scss']
})
export class TicketBasketRaffleAllocationListPageComponent implements OnInit, AfterViewInit,OnDestroy {

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  public selectedCampaignId;
  constructor(
    private route: ActivatedRoute,
    private routeReuseStrategyService: RouteReuseStrategyService,
    public ticketsAndGuestsStateService:TicketsAndGuestsStateService
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    this.route.params.pipe(
      first(),
      takeUntil(this.takeUntilSubject)
    ).subscribe(params => {
      this.selectedCampaignId = this.ticketsAndGuestsStateService.selectedCampaignId;
      let paramsUrl = this.route.snapshot.queryParams
      window['orgMain'].showTicketBasketRaffleAllocationList({
        id: params.id,
      }, this.ticketsAndGuestsStateService);
    });
    
  }

  ngOnDestroy(): void {
    window["$"]('#ticketGuestList').empty()
    window["$"]('#ticketGuestList').hide()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  
    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }
}
